import ComplianceTemplate from '@components/templates/ComplianceTemplate/ComplianceTemplate'
import { initializeApollo } from '@gql/client'
import { api as pagebuilderApi } from 'react-pagebuilder/services/api'
import { CATEGORIA_PRODOTTO, PAGINA, PagineCatchAllDocument } from 'utils/queries'
import { PAGINA_TEMPLATE_LANDING } from 'utils/settings'
import { PaginaType } from 'utils/types'
import LandingProdottoTemplate from 'components/templates/LandingProdottoTemplate/LandingProdottoTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

interface Props {
  pagina: PaginaType
  categoriaProdotto?: any
  defaultContent?: any
}

function Page({ pagina, categoriaProdotto, defaultContent }: Props) {
  return categoriaProdotto ? (
    <LandingProdottoTemplate
      pagina={pagina}
      categoria={categoriaProdotto}
      variant={categoriaProdotto.template} // TODO: gestire caso empty
    />
  ) : (
    <ComplianceTemplate pagina={pagina} defaultContent={defaultContent} />
  )
}

export const getStaticPaths = NextWrapper.getStaticPaths(async () => {
  const client = initializeApollo()

  const {
    data: { pagine },
  } = await client.query({
    query: PagineCatchAllDocument,
  })

  const paths = pagine.edges
    .filter((x) => !['/cookie-policy', '/mappa-del-sito'].includes(x.node.path))
    .map((x) => ({
      params: { path: x.node.path.split('/').slice(1) },
    }))

  return {
    paths,
    fallback: 'blocking',
  }
}, '/[path]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { path }, preview, previewData }) => {
    const route = '/' + path.join('/')

    // per evitare che in locale venga gestito media url da frontend
    if (route.includes('/media/filer')) {
      return { notFound: true }
    }

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const client = initializeApollo()

    const {
      data: { pagina },
    } = await client.query({
      query: PAGINA,
      variables: { path: route, preview: preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    let categoriaProdotto = null
    let defaultContent = null

    if (pagina.template === PAGINA_TEMPLATE_LANDING) {
      const {
        data: { categoriaProdotto: categoria },
      } = await client.query({
        query: CATEGORIA_PRODOTTO,
        variables: { slug: route.replace(/\//g, '') },
        context: {
          headers,
        },
      })
      categoriaProdotto = categoria
    } else {
      try {
        defaultContent = await pagebuilderApi.getPagebuilder({
          contentTypeId: pagina.model,
          objectId: pagina.pk,
          key: 'content',
          edit_mode: false,
        })
      } catch (err) {
        console.log(err)
      }
    }

    return {
      props: {
        pagina,
        categoriaProdotto,
        defaultContent,
        key: pagina.pk,
      },
      revalidate: 60 * 2,
    }
  },
  '/[path]'
)

export default Page
